import React from 'react'

export interface CardProps {
  /**
   * Card content
   */
  children: React.ReactNode
  /**
   * Card title
   */
  title?: string
  /**
   * Card padding
   */
  padding?: 'sm' | 'md' | 'lg'
  /**
   * Enable shadow
   */
  shadow?: boolean
  /**
   * Additional CSS classes
   */
  className?: string
}

/**
 * A flexible card component for containing content
 */
export const Card: React.FC<CardProps> = ({
  children,
  title,
  padding = 'md',
  shadow = true,
  className = '',
}) => {
  const baseClasses = 'bg-white rounded-lg border border-gray-200'
  
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  }
  
  const shadowClasses = shadow ? 'shadow-sm hover:shadow-md transition-shadow' : ''
  
  const classes = [
    baseClasses,
    paddingClasses[padding],
    shadowClasses,
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classes}>
      {title && (
        <div className="mb-4">
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        </div>
      )}
      {children}
    </div>
  )
}